module.exports = __webpack_public_path__ + "static/media/cuaderno.87a93f20.svg";